<nz-empty nzNotFoundImage="simple" [nzNotFoundContent]="'common.noData' | translate"></nz-empty>
